export const AlertResponseEnum={
    Save : "Save",
    Cancel :"Cancel",
    DontSave :"DontSave",
}